import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements AfterViewInit, OnChanges {
  @Input() public terms: any;
  @Input() public termsPath: string = '';
  @Input() public tableBorders: any[] = [];
  @Input() public imageSizes: any[] = [];
  @ViewChild('termsContent', { static: false }) private termsContent!: ElementRef;

  constructor() { }

  ngAfterViewInit(): void {
    setTimeout(() => this.applyTableBorders(), 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.terms || changes.tableBorders || changes.imageSizes) {
      setTimeout(() => this.applyTableBorders(), 100);
    }
  }

  private applyTableBorders(): void {
    const content = this.termsContent && this.termsContent.nativeElement as HTMLElement;
    if (!content) {
      return;
    }

    Array.prototype.slice.call(content.querySelectorAll('img')).forEach((image: HTMLImageElement, index: number) => {
      const size = this.imageSizes[index];
      if (size && size.width) {
        image.style.setProperty('width', size.width);
      }
      image.style.setProperty('height', 'auto');
      image.style.setProperty('max-width', '100%');
      image.style.setProperty('box-sizing', 'border-box');
    });

    Array.prototype.slice.call(content.querySelectorAll('table')).forEach((table: HTMLTableElement, index: number) => {
      const borders = this.tableBorders[index];
      if (!borders) {
        return;
      }

      ['top', 'right', 'bottom', 'left'].forEach(side => {
        if (borders[side]) {
          table.style.setProperty(`border-${side}`, borders[side]);
        }
      });
      if (borders.width) {
        table.style.setProperty('width', borders.width);
      }
      table.style.setProperty('max-width', '100%');
      table.style.setProperty('box-sizing', 'border-box');
      if (borders.cellMargins) {
        table.querySelectorAll('td, th').forEach((cell: Element) => {
          Object.keys(borders.cellMargins).forEach(side => {
            cell.setAttribute('style', `${cell.getAttribute('style') || ''} padding-${side}: ${borders.cellMargins[side]};`);
          });
        });
      }
      if (borders.insideH) {
        Array.prototype.slice.call(table.rows, 1).forEach((row: HTMLTableRowElement) =>
          Array.prototype.slice.call(row.cells).forEach((cell: HTMLTableCellElement) =>
            cell.style.setProperty('border-top', borders.insideH)));
      }
      if (borders.insideV) {
        Array.prototype.slice.call(table.rows).forEach((row: HTMLTableRowElement) =>
          Array.prototype.slice.call(row.cells, 1).forEach((cell: HTMLTableCellElement) =>
            cell.style.setProperty('border-left', borders.insideV)));
      }
    });
  }

}
